/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PrincipiosActivosControllerActualizarPrincipiosActivos$Params {
  hilosListado: string;
  hilosPrincipiosActivos: string;
  limpiarCache: boolean;
}

export function principiosActivosControllerActualizarPrincipiosActivos(http: HttpClient, rootUrl: string, params: PrincipiosActivosControllerActualizarPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, principiosActivosControllerActualizarPrincipiosActivos.PATH, 'get');
  if (params) {
    rb.query('hilosListado', params.hilosListado, {});
    rb.query('hilosPrincipiosActivos', params.hilosPrincipiosActivos, {});
    rb.query('limpiarCache', params.limpiarCache, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

principiosActivosControllerActualizarPrincipiosActivos.PATH = '/api/principios-activos/actualizar-principios-activos';
